import { ChangePassword } from './ChangePassword.js';
import { RecoverPassword } from './RecoverPassword.js';
import { UserPolicies } from './UserPolicies.js';
import { User } from '../../../models/User/User.js';

class Users {
  constructor(apiClient) {
    this.apiClient = apiClient;
    this.changePassword = new ChangePassword(apiClient);
    this.policies = new UserPolicies(apiClient);
    this.recoverPassword = new RecoverPassword(apiClient);
  }
  get() {
    return this.apiClient.get('v1/users').then(response => User.createFromResponse(response.data));
  }
  updateLanguage(language) {
    return this.apiClient.put('v1/users/language', {
      language
    }).then(response => response.data);
  }
}

export { Users };
//# sourceMappingURL=Users.js.map
